import ClusterManagementSearch from "./ClusterManagementSearch";
export default {
  datanode: {
    ClusterManagementSearch
  }
};
